export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-bold-b2b2a01cd875532e9436c509c44f6172.woff2";